// Module
var code = "<h2 id=\"still-have-questions\">Still Have Questions?</h2> <p>Review our FAQ to get answers to your questions.</p> ";
// Exports
export default code;